import React from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import RUTAS from '../routes'

export const GoBack = () => {
    const navigation = useNavigate()

    return (
        <Button
            variant='text'
            color='primary'
            onClick={() => navigation(`/${RUTAS.PANEL}`)}
            startIcon={<ArrowBackIcon />}
        >
            Volver
        </Button>
    )
}
